import { ClipboardModule } from '@angular/cdk/clipboard'
import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { DatePipe } from '../../pipes'
import { BadgeComponent } from '../badge'
import { IconComponent } from '../icon'
import { LineLoaderComponent } from '../line-loader'
import { RemoteButtonComponent } from '../remote-button'
import { ToastModule } from '../toast'
import { TooltipModule } from '../tooltip'
import { TableCellActionComponent } from './table-cell-action.component'
import { TableCellComponent } from './table-cell.component'
import { TableColumnHeaderComponent } from './table-column-header.component'
import { TableComponent } from './table.component'

const COMPONENTS = [TableCellComponent, TableColumnHeaderComponent, TableComponent, TableCellActionComponent]

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    IconComponent,
    RemoteButtonComponent,
    BadgeComponent,
    LineLoaderComponent,
    TooltipModule,
    ClipboardModule,
    ToastModule,
    DatePipe,
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS,
})
export class TableModule {}
